// @ts-ignore
import { pathOr } from "ramda";
import { App } from "vue";

const errorHandling = {
  install(app: App) {
    const vm = app.config.globalProperties;
    const generateError = (error: any) => {
      const status = pathOr(null, ["response", "status"], error);
      if (!status || status === 401) return;

      const errorMessage = pathOr(
        null,
        ["data", "data", "error"],
        error.response
      );
      if (errorMessage === "invalid_credentials") {
        return vm.$notify.error(vm.$("error_message_login"));
      }

      let messages: any = [];
      if (status === 422) {
        const errors: any = pathOr(null, ["response", "data", "errors"], error);
        const errorsKeys = Object.keys(errors);
        for (const key of errorsKeys) {
          const newErrors = errors[key];
          messages = [...newErrors];
        }
      } else {
        messages = pathOr([], ["response", "data", "message"], error);
      }

      if (Array.isArray(messages)) {
        messages.forEach((message: any) => vm.$notify.error(message));
      } else {
        vm.$notify.error(messages);
      }
    };

    const generateErrorHook = (error: any) => {
      const status = pathOr(null, ["response", "status"], error);
      if (!status || status === 401) return;

      const errorMessage = pathOr(null, ["data", "error"], error);
      if (errorMessage === "invalid_credentials") {
        return vm.$notify.error(vm.$("error_message_login"));
      }

      let messages: any = [];
      if (status === 422) {
        const errors: any = pathOr(null, ["data", "message"], error);
        const errorsKeys = Object.keys(errors);
        for (const key of errorsKeys) {
          const newErrors = errors[key];
          messages = [...newErrors];
        }
      } else {
        messages = pathOr([], ["data", "message"], error);
      }

      if (Array.isArray(messages)) {
        messages.forEach((message: any) => vm.$notify.error(message));
      } else {
        vm.$notify.error(messages);
      }
    };

    vm.$generateError = generateError;

    app.provide("generateError", generateError);
    app.provide("generateErrorHook", generateErrorHook);
  },
};

export default errorHandling;
